import React from "react";
import '../assets/css/style.css';
import { Outlet } from "react-router-dom";
import useInactivityTimeout from "../Hooks/useInactivityTimeout";

const OldStyleComponent = () => {
    // Hook gets timeout from API (user data), defaults to 2 if null
    useInactivityTimeout(true, 1); // showWarning=true, warningMinutes=1
    
    return (
        <Outlet />
    )
}
export default OldStyleComponent;